import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateReportSchemeState } from "../../Store";
import ApiHelper from "../../../../../../Helpers/ApiHelper";
import ReportItemEntityListRow from "../Entities/ReportItemEntityListRow";

export default function ImageSpace({ entity, UpdateScheme, children }) {
  const user = useSelector((state) => state.auth.user);

  const dispatch = useDispatch();
  const entityList = useSelector((state) => state.reportScheme.visibleReportItemEntityList);

  const deleteElement = async () => {
    let newList = JSON.parse(JSON.stringify(entityList));
    const res = await DeleteFromDb();

    if (res) {
      newList.splice(entity.order - 1, 1);
      newList.forEach((entity, i) => {
        entity.order = i + 1;
      });
      dispatch(updateReportSchemeState({ visibleReportItemEntityList: newList }));
      UpdateScheme(newList);
    }
  };

  let DeleteFromDb = async () => {
    // setShowOverlay(true);

    return new Promise(function (resolve, reject) {
      ApiHelper.getAsync(
        "report/DeleteImage",
        { fileName: entity.imageName },
        function (result) {
          if (result.data.statusCode == 1) resolve(true);
          else {
            alert("hata olustu sayfa yenile");
            resolve(false);
          }
        },
        user.token
      );
    }).then((val) => {
      return val;
    });
  };

  return (
    <>
      <div className="report-scheme-report-item-row">
        <ReportItemEntityListRow entity={entity} itemName="Görsel" />
        {children && children}
      </div>

      {children && children}
    </>
  );
}
